import { GoogleBusinessLogo, JamedaLogo, KununuLogo } from "../../client/dashboard/platformCatalog";

export function getPlatforms(t) {
  return [
    {
      id: "google",
      title: "Google Business",
      description: t("platforms.googleDesc"),
      badge: t("platforms.googleBadge"),
      Logo: GoogleBusinessLogo,
    },
    {
      id: "jameda",
      title: "Jameda",
      description: t("platforms.jamedaDesc"),
      badge: t("platforms.jamedaBadge"),
      Logo: JamedaLogo,
    },
    // Kununu is intentionally not listed yet — no backend integration exists.
    // Re-add here once the Kununu connector ships. The logo/i18n are kept.
  ];
}

export function getPlatformById(id, t) {
  return getPlatforms(t).find((p) => p.id === id);
}

export function googleStepCopy(t, step, meta) {
  if (step === "disconnect") {
    return {
      title: t("platforms.disconnecting"),
      detail: t("platforms.disconnectingDetail"),
    };
  }
  if (step === "oauth_callback") {
    return {
      title: t("platforms.oauthTitle"),
      detail: t("platforms.oauthDetail"),
    };
  }
  if (step === "accounts") {
    return {
      title: t("platforms.accountsTitle"),
      detail: t("platforms.accountsDetail"),
    };
  }
  if (step === "locations" && meta?.total > 0) {
    return {
      title: t("platforms.locationsTitle"),
      detail: t("platforms.locationsDetail", {
        index: meta.index,
        total: meta.total,
      }),
    };
  }
  if (step === "locations") {
    return {
      title: t("platforms.locationsTitle"),
      detail: t("platforms.accountsDetail"),
    };
  }
  return {
    title: "Google Business",
    detail: t("platforms.waitServer"),
  };
}

export function formatRelativeTime(t, ts) {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return t("platforms.relativeJustNow");
  const m = Math.floor(s / 60);
  if (m < 60) return t("platforms.relativeMinutes", { count: m });
  const h = Math.floor(m / 60);
  if (h < 24) return t("platforms.relativeHours", { count: h });
  const d = Math.floor(h / 24);
  return d === 1
    ? t("platforms.relativeDays", { count: d })
    : t("platforms.relativeDaysPlural", { count: d });
}

export function formatAvgRating(value, locale) {
  const formatted = value.toFixed(1);
  const display = locale === "de" ? formatted.replace(".", ",") : formatted;
  return `${display} / 5`;
}
